import React from 'react';
import { useAppData } from '../AppContext';
import { DEF_COMPANY_TRUST } from '../store';
import './CompanyTrust.css';

const CompanyTrust = () => {
  const { companyTrust } = useAppData();
  const ct = companyTrust || DEF_COMPANY_TRUST;
  const { jgi, jgzt } = ct;

  return (
    <>
      <section className="about-jgi-section">
        <div className="about-container">
          <h2 className="about-heading" data-aos="fade-up">{jgi.heading}</h2>
          <div className="about-jgi-grid" data-aos="fade-up" data-aos-delay="80">
            <div className="about-jgi-text">
              <p>{jgi.para1}</p>
              <p>{jgi.para2}</p>
              <ul>
                {jgi.bullets.map((b, i) => <li key={i}><strong>{b}</strong></li>)}
              </ul>
              <p>{jgi.para3}</p>
            </div>

          </div>
        </div>
      </section>

      <section className="about-jgzt-section">
        <div className="about-container">
          <h2 className="about-heading" data-aos="fade-up">{jgzt.heading}</h2>
          <p className="about-body-text">{jgzt.para1}</p>
          <p className="about-body-text">{jgzt.para2}</p>
        </div>
      </section>


    </>
  );
};

export default CompanyTrust;
